import { embedQuizType } from "./commonFunctions";
import { QUIZ_TYPE_BGT, QUIZ_TYPE_CT } from "./constants";

  const isBGT = embedQuizType() === QUIZ_TYPE_BGT;
  const isChampionsTrophy = embedQuizType() === QUIZ_TYPE_CT;

export const menu = () => [
  {
    route: '',
    name: 'Home',
    displayOnNav: true
  },
  {
    route: 'leaderboard',
    name: 'Leaderboard',
    displayOnNav: true
  },
  {
    route: 'rules',
    name: (isBGT || isChampionsTrophy) ? 'How To Play' : 'Rules',
    displayOnNav: true,
    hideInEOT: true
  },
  {
    route: 'prizes',
    name: 'Rules & Prizes',
    displayOnNav: true,
    hideForTypes: ['Daily', 'Topical', 'Archive'],
    hideInEOT: true
  },
  {
    route: 'game',
    name: 'Game',
    displayOnNav: false
  },
  {
    route: 'result',
    name: 'Result',
    displayOnNav: false
  }
];

export const howToPlayCards = [
  {
    imageName: 'htp-1.png',
    content:
      'Answer 10 questions each day, with bonus points for successful streaks and time remaining'
  },
  {
    imageName: 'htp-2.png',
    content: "Use the '50/50' and 'Third Umpire' lifelines to boost your chances"
  },
  {
    imageName: 'htp-3.png',
    content: 'Share with your friends'
  }
];

export const config = {};
